module.exports = __webpack_public_path__ + "static/media/sake_luks.8d8b0bd3.jpeg";